import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../context/ThemeContext';
import { Button } from './Button';
import { ThemedText } from './ThemedText';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${props => props.isOpen ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 10001;
  padding: ${props => props.theme.spacing.md};
`;

const DialogBox = styled.div`
  background-color: ${props => props.theme.colors.background};
  border-radius: ${props => props.theme.borderRadius.lg};
  padding: ${props => props.theme.spacing.xl};
  max-width: 440px;
  width: 100%;
  box-shadow: ${props => props.theme.shadows.xl};
`;

const DialogTitle = styled.div`
  margin-bottom: ${props => props.theme.spacing.md};
`;

const DialogMessage = styled.div`
  margin-bottom: ${props => props.theme.spacing.lg};
`;

const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${props => props.theme.spacing.md};
`;

export const ConfirmDialog = ({
  isOpen,
  title = 'Confirm Delete',
  message = 'Are you sure? This action cannot be undone.',
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  const theme = useTheme();

  if (!isOpen) return null;

  return (
    <Overlay theme={theme} isOpen={isOpen} onClick={onCancel}>
      <DialogBox theme={theme} onClick={(e) => e.stopPropagation()}>
        <DialogTitle theme={theme}>
          <ThemedText type="subtitle">{title}</ThemedText>
        </DialogTitle>
        <DialogMessage theme={theme}>
          <ThemedText>{message}</ThemedText>
        </DialogMessage>
        <DialogActions theme={theme}>
          <Button variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </DialogActions>
      </DialogBox>
    </Overlay>
  );
};
